import { render, staticRenderFns } from "./RestoreCustomer.vue?vue&type=template&id=7aa99504&scoped=true"
import script from "./RestoreCustomer.vue?vue&type=script&lang=js"
export * from "./RestoreCustomer.vue?vue&type=script&lang=js"
import style0 from "./RestoreCustomer.vue?vue&type=style&index=0&id=7aa99504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa99504",
  null
  
)

export default component.exports